import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import BasicPieGraph from '../../../components/graphs/BasicPieGraph';
import api from '../../../lib/api';
import UserTableModal from '../modals/UserTableModal';
import LoadingOverlay from 'react-loading-overlay';

const styles = {
  percentageBox: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: 'bold',
    padding: '0rem 0rem 2rem 0rem',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'between',
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
  title: {
    textAlign: 'center',
    marginTop: '2rem',
    marginBottom: '2rem',
  },
  formItem: {
    width: '20%',
    flexGrow: 1,
    paddingRight: '10px',
  },
  formSubmit: {
    alignSelf: 'end',
    flexGrow: 1,
  },
  formSubmitBtn: {
    width: '100%',
    color: 'white',
    padding: '11px',
    borderRadius: '3px',
    backgroundColor: '#2196f3',
    border: '1px solid #2196f3',
    cursor: 'pointer',
  },
  formInput: {
    width: '95%',
    marginTop: '5px',
    padding: '10px',
  },
};

class RedemptionRateGraphCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      data: null,
      pieDatas: [],
      percentage: 0,
      isModalOpen: false,
      modalUsers: [],
      serieName: '',
      form: {
        year: '',
        month_start: '',
        month_end: '',
      },
    };
  }

  componentDidMount() {
    const { month, year } = this.getStartingDates();

    this.setState({
      form: {
        year: year,
        month_start: month,
        month_end: month,
      },
    });

    this.filterResults();
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value, // aggiorna il campo specifico
      },
    }));
  };

  handleSubmit = event => {
    event.preventDefault();
    this.filterResults();
  };

  handleSeriesClick = serie => {
    const { month, year } = this.getStartingDates();

    this.setState({ loading: true });

    api({
      url: `/dashboard/redemption_rate?type=user_list&year=${this.state.form.year || year}&month_start=${this.state.form
        .month_start || month}&month_end=${this.state.form.month_end || month}`,
      method: 'GET',
    })
      .then(({ data }) => {
        let users = [];

        switch (serie.name) {
          case 'Vecchi abbonati senza rinnovo con scadenza nel range':
            users = data.vecchi_abbonati_senza_rinnovo_in_questo_range;
            break;
          case 'Abbonati rinnovati con scadenza nel range':
            users = data.vecchi_abbonati_rinnovati_con_expired_nel_range;
            break;
          case 'Abbonati rinnovati con scadenza prima del range':
            users = data.vecchi_abbonati_rinnovati_con_expired_prima_del_range;
            break;
        }

        this.setState({ modalUsers: users });
        this.setState({ serieName: serie.name });

        this.openModal();
      })
      .catch(error => this.setState({ error }))
      .finally(() => this.setState({ loading: false }));
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  getStartingDates = () => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    return {
      month: month,
      year: year,
    };
  };

  filterResults = () => {
    const { month, year } = this.getStartingDates();

    this.setState({ loading: true });

    api({
      url: `/dashboard/redemption_rate?year=${this.state.form.year || year}&month_start=${this.state.form.month_start ||
        month}&month_end=${this.state.form.month_end || month}`,
      method: 'GET',
    })
      .then(({ data }) => {
        this.setState({ loading: false });

        const {
          totale_vecchi_abbonati_rinnovati_con_expired_nel_range,
          totale_vecchi_abbonati_rinnovati_con_expired_prima_del_range,
          totale_vecchi_abbonati_senza_rinnovo_in_questo_range,
        } = data;

        const renew =
          totale_vecchi_abbonati_rinnovati_con_expired_nel_range +
          totale_vecchi_abbonati_rinnovati_con_expired_prima_del_range;
        const total = renew + totale_vecchi_abbonati_senza_rinnovo_in_questo_range;
        if (total !== 0) {
          const percentage = ((renew / total) * 100).toFixed(1);
          this.setState({ percentage: percentage });
        }

        const pieDatas = [
          {
            value: totale_vecchi_abbonati_rinnovati_con_expired_nel_range || 0,
            name: 'Abbonati rinnovati con scadenza nel range',
          },
          {
            value: totale_vecchi_abbonati_rinnovati_con_expired_prima_del_range || 0,
            name: 'Abbonati rinnovati con scadenza prima del range',
          },
          {
            value: totale_vecchi_abbonati_senza_rinnovo_in_questo_range || 0,
            name: 'Vecchi abbonati senza rinnovo con scadenza nel range',
          },
        ];

        this.setState({ pieDatas: pieDatas });
      })
      .catch(error => this.setState({ error }))
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { classes } = this.props;
    const { loading, error, form, pieDatas } = this.state;

    if (error) return <p>Error: {error.message}</p>;

    return (
      <React.Fragment>
        <LoadingOverlay
          styles={{
            overlay: base => ({
              ...base,
              background: '#2196f357',
              borderRadius: '10px',
            }),
          }}
          active={loading}
          spinner
          text="Caricamento..."
        >
          {/* Redemption Pie */}
          <div style={{ marginTop: '1rem' }}>
            <Card style={styles.card}>
              <div>
                <h2 className={classes.title}>Tasso di Redemption</h2>
                <h4 style={{ padding: '0rem 1rem', textAlign: 'center' }}>
                  Il tasso di redemption indica la quantità di utenti rinnovati dopo la scadenza di un abbonamento
                  <div>
                    <small>&nbsp;</small>
                  </div>
                </h4>
              </div>

              <form className={classes.form} onSubmit={this.handleSubmit}>
                <div className={classes.formItem}>
                  <label htmlFor="year">Anno</label>
                  <div>
                    <input
                      className={classes.formInput}
                      name="year"
                      type="number"
                      min="2015"
                      max={new Date().getFullYear()}
                      value={form.year}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className={classes.formItem}>
                  <label htmlFor="month_start">Mese di partenza</label>
                  <div>
                    <input
                      className={classes.formInput}
                      name="month_start"
                      type="number"
                      min="1"
                      max="12"
                      value={form.month_start}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className={classes.formItem}>
                  <label htmlFor="month_end">Mese di arrivo</label>
                  <div>
                    <input
                      className={classes.formInput}
                      name="month_end"
                      type="number"
                      min="1"
                      max="12"
                      value={form.month_end}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className={classes.formSubmit}>
                  <button type="submit" className={classes.formSubmitBtn}>
                    Filtra
                  </button>
                </div>
              </form>

              <BasicPieGraph
                colors={['#95D178' /** Green */, '#5470C6' /** blue */, '#EE6766' /** Red */]}
                datas={pieDatas}
                handleSeriesClick={this.handleSeriesClick}
              />

              <div className={classes.percentageBox}>{this.state.percentage}%</div>
            </Card>
          </div>

          <UserTableModal
            title={`Tasso di redemption`}
            subtitle={this.state.serieName}
            closeModal={this.closeModal}
            isModalOpen={this.state.isModalOpen}
            users={this.state.modalUsers}
          />
        </LoadingOverlay>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(RedemptionRateGraphCard);



// WEBPACK FOOTER //
// ./src/resources/dashboard/graphs/RedemptionRateGraphCard.jsx